import React, { useState, useEffect } from 'react';
import UsersList from './UsersList';
import ViewUser from './ViewUser';
import ResizablePanels from '../../components/Layout/ResizablePanels';
import './Users.css';

function Users({ initialViewMode, initialUserId }) {
  const [selectedUserId, setSelectedUserId] = useState(initialUserId || null);
  const [viewMode, setViewMode] = useState(initialViewMode || 'list'); // 'list', 'view', 'edit', 'create'

  useEffect(() => {
    // Set toolbar based on current mode
    if (window.setToolbar) {
      if (viewMode === 'list') {
        window.setToolbar({
          title: 'Users',
          buttons: [
            {
              label: 'New User',
              icon: '➕',
              onClick: handleNew,
              variant: 'primary'
            },
            {
              label: 'Refresh',
              icon: '🔄',
              onClick: handleRefresh
            }
          ]
        });
      } else if (viewMode === 'view') {
        window.setToolbar({
          title: 'View User',
          showBack: true,
          onBack: handleBack,
          buttons: [
            {
              label: 'Edit',
              icon: '✏️',
              onClick: handleEdit,
              variant: 'secondary'
            },
            {
              label: 'Delete',
              icon: '🗑️',
              onClick: handleDelete,
              variant: 'danger'
            }
          ]
        });
      } else if (viewMode === 'edit') {
        window.setToolbar({
          title: 'Edit User',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Save',
              icon: '💾',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      } else if (viewMode === 'create') {
        window.setToolbar({
          title: 'New User',
          showBack: false,
          buttons: [
            {
              label: 'Cancel',
              onClick: handleCancel,
              variant: 'secondary'
            },
            {
              label: 'Create',
              icon: '➕',
              onClick: handleSave,
              variant: 'primary'
            }
          ]
        });
      }
    }

    return () => {
      if (window.setToolbar) {
        window.setToolbar(null);
      }
    };
  }, [viewMode]);

  const handleSelectUser = (userId) => {
    setSelectedUserId(userId);
    setViewMode('view');
  };

  const handleNew = () => {
    setSelectedUserId(null);
    setViewMode('create');
  };

  const handleEdit = () => {
    setViewMode('edit');
  };

  const handleDelete = () => {
    // Delete will be handled in ViewUser component
    if (window.viewUserRef && window.viewUserRef.handleDelete) {
      window.viewUserRef.handleDelete();
    }
  };

  const handleSave = () => {
    // Save will be handled in ViewUser component
    if (window.viewUserRef && window.viewUserRef.handleSave) {
      window.viewUserRef.handleSave();
    }
  };

  const handleCancel = () => {
    if (viewMode === 'create') {
      setViewMode('list');
      setSelectedUserId(null);
    } else {
      setViewMode('view');
    }
  };

  const handleBack = () => {
    setViewMode('list');
    setSelectedUserId(null);
  };

  const handleRefresh = () => {
    // Trigger refresh in UsersList
    if (window.usersListRef && window.usersListRef.fetchUsers) {
      window.usersListRef.fetchUsers();
    }
  };

  const handleUserSaved = (user) => {
    setSelectedUserId(user.user_id || user.id);
    setViewMode('view');
    // Refresh the list
    if (window.usersListRef && window.usersListRef.fetchUsers) {
      window.usersListRef.fetchUsers();
    }
  };

  const handleUserCreated = (userId) => {
    setSelectedUserId(userId);
    setViewMode('view');
    // Refresh the list
    if (window.usersListRef && window.usersListRef.fetchUsers) {
      window.usersListRef.fetchUsers();
    }
  };

  return (
    <div className="users-page">
      <ResizablePanels
        leftPanel={
          <UsersList
            ref={ref => window.usersListRef = ref}
            onSelectUser={handleSelectUser}
            selectedUserId={selectedUserId}
            onNew={handleNew}
          />
        }
        rightPanel={
          viewMode !== 'list' ? (
            <ViewUser
              ref={ref => window.viewUserRef = ref}
              userId={selectedUserId}
              onBack={handleBack}
              editMode={viewMode === 'edit'}
              createMode={viewMode === 'create'}
              onSave={handleUserSaved}
              onCancel={handleCancel}
              onEdit={handleEdit}
              onUserCreated={handleUserCreated}
            />
          ) : null
        }
        leftCollapsed={viewMode !== 'list'}
        defaultLeftWidth={40}
        minLeftWidth={30}
        maxLeftWidth={70}
      />
    </div>
  );
}

export default Users;